<script lang="ts">
import { I3pEventsEnum } from '@nuxtDatakodeUtils/types/I3pEvents.enum'
import OpportunityListPanel from '~/components/I3pComponent/opportunities/ListPanel.vue'
import OpportunityTopButtons from '~/components/I3pComponent/opportunities/TopButtons.vue'
import OpportunityEntityPanel from '~/components/I3pComponent/opportunities/EntityPanel.vue'
import { OpportunitiesI3pService } from '~/services/opportunities.i3p.service'
import NavigationModeSwitcher from '~/components/I3pComponent/common/map/NavigationModeSwitcher.vue'
import MapPanelOpportunity from '~/components/I3pComponent/opportunities/MapPanel.vue'
import { OpportunityEnum } from '~/enum/Opportunity.enum'

export default {
    name: 'OpportunitiesI3p',
    components: {
        MapPanelOpportunity,
        OpportunityEntityPanel,
        OpportunityTopButtons,
        OpportunityListPanel,
        NavigationModeSwitcher,
    },
    props: {
        i3pService: { type: OpportunitiesI3pService, required: true },
        baseUrl: { type: String, required: true },
    },
    data() {
        return {
            intentionsGeojson: null,
            intentionsCurrentEntityK: null,
            navigationModeInitialValue: 'zoomOnItem',
        }
    },
    async mounted() {
        this.i3pService.emitter
            .on(I3pEventsEnum.entityNotFound, (event: { currentEntityK: string }) => {
                this.$showToaster({
                    title: `Opportunité ${event.currentEntityK} non trouvée !`,
                    text: '',
                    color: 'danger',
                    icon: 'mdi-alert',
                })
            })

        this.i3pService.emitter
            .on(OpportunityEnum.changeCurrentIntentionK, (event: { currentIntentionK: string }) => {
                const k = event.currentIntentionK
                const hasChanged = k !== this.intentionsCurrentEntityK
                if (hasChanged && k) {
                    this.intentionsCurrentEntityK = k
                }
                else {
                    this.intentionsCurrentEntityK = null
                }
            })

        await this.i3pService.loadData(!this.$route.params.k)
    },
    methods: {
        changeNavigationMode(navigationMode: NavigationMode): void {
            this.i3pService.setNavigationMode(navigationMode)
            this.navigationModeInitialValue = navigationMode
            if (navigationMode === 'zoomOnItem') {
                this.$refs.mapPanel?.zoomOnCurrentItem()
            }
            if (navigationMode === 'displayAll') {
                this.$refs.mapPanel?.displayAll()
            }
        },
        clickIntentionPanelHeader(evt): void {
            if (evt.k) {
                this.i3pService.emitter.emit(OpportunityEnum.changeCurrentIntentionK, { currentIntentionK: evt.k })
            }
        },
    },
}
</script>

<template>
    <I3p :i3p-service="i3pService">
        <template #topButtons>
            <div class="w-100 d-flex pb-2 justify-space-between align-center">
                <OpportunityTopButtons :base-url="baseUrl" />
                <NavigationModeSwitcher :initial-value="navigationModeInitialValue" @change-mode="changeNavigationMode($event)" />
            </div>
        </template>
        <template #map-panel>
            <MapPanelOpportunity ref="mapPanel" />
        </template>
        <template #list-panel>
            <OpportunityListPanel :base-url="baseUrl" />
        </template>
        <template #entity-panel>
            <OpportunityEntityPanel
                :base-url="baseUrl" :current-intention-k="intentionsCurrentEntityK"
                @select-intention-k="clickIntentionPanelHeader"
            />
        </template>
        <template #bottomButtons>
            <I3pPanelsEditButtonsBottom />
        </template>
    </I3p>
</template>
